import router from "@/router";
import httpClient from "@/services/httpClient";
import { server } from "@/services/constant";
import * as alumniAPIS from "@/services/api_alumni";

const isToken = async () => {
  let token = localStorage.getItem(server.TOKEN_KEY);

  if (token) {
    const data = {
      token: localStorage.getItem(server.TOKEN_KEY),
    };
    let result = await httpClient.post("api/login_std/auth_login_alumni", data);
    if (result.data.result === true) {
      router.push("/main");
    } else {
      router.push("/login");
    }
  } else {
    router.push("/login");
  } //check if login
};

const isCheckToken = async () => {
  const data = {
    token: localStorage.getItem(server.TOKEN_KEY),
  };
  let result = await httpClient.post("api/login_std/auth_login_alumni", data);
  if (result.data.result === true) {
    return true;
  } else {
    return false;
  }
};

const login = async (values) => {
  try {
    let result = await httpClient.post("api/login_std/login_alumni", values);
    if (result.data.qData === true) {
      localStorage.setItem(server.TOKEN_KEY, result.data.token);
      router.push("/main");
      return true;
    }
  } catch (error) {
    alert("ไม่พบข้อมูลของท่าน");
    return false;
  }
};
const isLoggedIn = () => {
  let token = localStorage.getItem(server.TOKEN_KEY);
  var hours = 3; // Reset when storage is more than 24hours
  var now = Date.now();
  var setupTime = localStorage.getItem("setupTime");

  if (setupTime == null) {
    localStorage.setItem("setupTime", now);
  } else if (now - setupTime > hours * 60 * 60 * 1000) {
    localStorage.removeItem("setupTime");
    localStorage.setItem("setupTime", now);
    router.push("/login");
  }

  if (!token) {
    router.push("/login");
  } else {
     return true;
  }
};

const logoff = () => {
  localStorage.removeItem(server.TOKEN_KEY);
  router.push("/login").catch(() => {});
};

const error = () => {
  localStorage.removeItem(server.TOKEN_KEY);
  router
    .push({
      path: "/error",
      query: { message: "Username or Password is wrong" },
    })
    .catch(() => {});
};

const maxWidthObject = () => {
  let windowWidth = window.innerWidth;
  let width = 0;

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    if (windowWidth <= 375) {
      width = windowWidth / 1.2;
      return width;
    } else {
      width = windowWidth / 1.5;
      return width;
    }
  } else {
    width = windowWidth / 1.3;
    return width;
  }
};

export default {
  isToken,
  isCheckToken,
  isLoggedIn,
  login,
  logoff,
  error,
  maxWidthObject,
  ...alumniAPIS,
};
